export var SalaryUnit;
(function (SalaryUnit) {
    SalaryUnit["HOUR"] = "HOUR";
    // DAY = 'DAY',
    // WEEK = 'WEEK',
    SalaryUnit["MONTH"] = "MONTH";
    SalaryUnit["YEAR"] = "YEAR";
})(SalaryUnit || (SalaryUnit = {}));
